import { TruckbookApiResponseError } from 'repositories/TruckbookApiResponseError'

/**
 * `TruckbookApiResponseError`（interceptor 配線済み client の 4xx）から
 * ユーザー向けメッセージを取り出す。envelope 外のエラー（ネットワーク等）は汎用文言にフォールバックする。
 *
 * `shipmentApiClient` のような `createTruckbookApiErrorInterceptor` 配線済み client を呼ぶ
 * hook の catch 節で利用する。詳細は `.claude/rules/error-handling.md` 参照。
 */
export const getTruckbookApiErrorMessage = (error: unknown): string =>
  error instanceof TruckbookApiResponseError
    ? error.message || 'エラーが発生しました'
    : '通信エラーが発生しました'
